import React, { createContext, useContext, useState, useEffect } from "react";
import config from "../../Config/Config";

// Create the context
export const CMSContext = createContext(); // Export the context here

// Hook to use the context
export const useCMS = () => {
  const context = useContext(CMSContext);
  if (!context) {
    throw new Error("useCMS must be used within a CMSProvider");
  }
  return context;
};

// Provider to fetch and share data
export const CMSProvider = ({ children }) => {
  const [cmsData, setCmsData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch CMS data from the API
  useEffect(() => {
    const fetchCMSData = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}/getallcms`); // Replace with your actual API
        const data = await response.json();
        setCmsData(data);
      } catch (error) {
        console.error("Error fetching CMS data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCMSData();
  }, []);

  // Provide the data to children components
  return (
    <CMSContext.Provider value={{ cmsData, loading }}>
      {children}
    </CMSContext.Provider>
  );
};
